<template>
    <ui-modal :title="title" xlarge :close="close">
        <template #icon>
            <div
                class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                <i class="far fa-window-restore text-blue-400"></i>
            </div>
        </template>
        <div class="my-2">
            <div class="flex mb-1">
                <label class="block text-sm font-medium text-gray-700 mt-1 mb-0 flex-grow"
                       v-text="'Text to search for'"></label>
                <label class="block text-sm font-light text-gray-500 mt-0 mb-0 flex-shrink mr-1"
                       v-text="'Partial matches?'"></label>
                <input type="checkbox" class="flex-shrink mt-px" v-model="partial" @change="updateCounts">
            </div>
            <div class="flex mb-1">
                <autoresizable-textarea :height="el => (el.scrollHeight + 2) + 'px'"
                                        ref="autoresizable-textarea">
                        <textarea
                            placeholder="Search text..."
                            class="text-sm m-0 px-2 pt-1.5 pb-0.5 border-1 border-gray-200 rounded shadow-none relative hover:z-10 focus:z-20 resize-none w-full"
                            type="text"
                            ref="name"
                            v-model="search"
                            @input="updateCounts"
                            @change="updateCounts"
                        ></textarea>
                </autoresizable-textarea>
            </div>
            <div class="flex mb-1">
                <label class="block text-sm font-medium text-gray-700 mt-1 mb-0 w-full" v-text="'Replace with'"></label>
            </div>
            <div class="flex mb-1">
                <autoresizable-textarea :height="el => (el.scrollHeight + 2) + 'px'"
                                        ref="autoresizable-textarea">
                        <textarea
                            placeholder="Replace text..."
                            class="text-sm m-0 px-2 pt-1.5 pb-0.5 border-1 border-gray-200 rounded shadow-none relative hover:z-10 focus:z-20 resize-none w-full"
                            type="text"
                            ref="name"
                            v-model="replace"
                            @input="updateCounts"
                            @change="updateCounts"
                        ></textarea>
                </autoresizable-textarea>
            </div>
            <div class="flex mb-2">
                <label class="block text-sm font-medium text-gray-700 mt-3 mb-0 flex-shrink mr-2"
                       v-text="'Scope'"></label>
                <ui-select :options="scopes" class="flex-grow" v-model="scope" @change="updateCounts"></ui-select>
            </div>
            <div class="flex mb-1">
                <div class="block text-xs text-gray-400" v-if="search===replace">Search and Replace are the same</div>
                <div class="block text-xs text-red-600" v-else-if="updateCount"><span v-text="updateCount"></span> items
                    will
                    have the description updated
                </div>
                <div class="block text-xs text-gray-400" v-else>No matching items</div>
            </div>

        </div>
        <template #footer-primary>
            <span class="mt-0 flex w-full sm:mt-0 sm:w-auto">
                <ui-button-new primary class="w-full whitespace-nowrap"
                               :loading="busy || !updateCount || (replace === search)"
                               @click="applyUpdate"
                               v-text="button"></ui-button-new>
            </span>
        </template>
    </ui-modal>
</template>

<script>
import UiInput from "../../ui/UiInput.vue";
import UiDataGridItem from "../../ui/UiDataGridItem.vue";
import UiDataGrid from "../../ui/UiDataGrid.vue";
import UiTextarea from "../../ui/UiTextarea.vue";
import UiModal from "../../ui/UiModal.vue";
import UiSelect from "../../ui/UiSelect.vue";
import UiButtonNew from "../../ui/UiButtonNew.vue";

export default {
    components: {UiButtonNew, UiSelect, UiModal, UiTextarea, UiDataGrid, UiDataGridItem, UiInput},
    props: {
        handle: Function,
        close: Function,
        title: {
            type: String,
            default: 'Find and Replace Descriptions'
        },
        button: {
            type: String,
            default: 'Apply Find & Replace'
        },
        estimate: Object,
        section: Object,
        task: Object,
        item: Object,
    },
    data() {
        return {
            search: '',
            replace: '',
            busy: false,
            scopes: [
                {value: 'estimate', label: 'Entire Estimate'},
                {value: 'section', label: 'Section : ' + this.section.title},
                {value: 'task', label: 'Task : ' + this.task.reference + ' ' + this.task.title},
            ],
            scope: 'estimate',
            partial: 0,
            updateCount: 0,
            items: [],
        }
    },
    methods: {
        applyUpdate() {
            this.handle(this);
            this.close();
        },
        updateCounts() {
            this.items = [];
            let match = function (item, search, items, partial) {
                if (item.bundle) {
                    item.bundle.forEach((bundleItem) => {
                        if (partial && (bundleItem.description.indexOf(search) !== -1)) {
                            items.push(bundleItem);
                        } else if (bundleItem.description === search) {
                            items.push(bundleItem);
                        }
                    })
                } else {
                    if (partial && (item.description.indexOf(search) !== -1)) {
                        items.push(item);
                    } else if (item.description === search) {
                        items.push(item);
                    }
                }
            };
            if (this.scope === 'estimate') {
                this.estimate.scopeOfWorks.forEach((section) => {
                    section.tasks.forEach((task) => {
                        task.items.forEach((item) => match(item, this.search, this.items, this.partial))
                    })
                })
            } else if (this.scope === 'section') {
                this.section.tasks.forEach((task) => {
                    task.items.forEach((item) => match(item, this.search, this.items, this.partial))
                })
            } else if (this.scope === 'task') {
                this.task.items.forEach((item) => match(item, this.search, this.items, this.partial))
            }
            this.updateCount = this.items.length;
        }
    },
    mounted() {
        this.search = this.item.description;
        this.replace = this.item.description;
        this.updateCounts()
    }
}
</script>
